import Layout from '@/components/feature/Layout';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedComics from '@/pages/home/components/FeaturedComics';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import ReaderReview from '@/pages/home/components/ReaderReview';
import CTASection from '@/pages/home/components/CTASection';
import FAQSection from '@/pages/home/components/FAQSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '韩漫大全',
      url: 'http://wiiohv.cn/',
      description: '韩漫网站，韩国漫画免费阅读第一站。通过韩漫网址便捷导航，浏览韩漫大全合集。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '韩漫网站_韩国漫画免费_韩漫网址_韩漫大全',
      description: '访问韩漫网站，免费享受韩国漫画，通过韩漫网址便捷导航，浏览韩漫大全合集，满足您对高质量漫画的阅读欲望。',
      url: 'http://wiiohv.cn/',
      isPartOf: { '@id': 'http://wiiohv.cn/#website' },
      about: { '@id': 'http://wiiohv.cn/#organization' },
    },
  ],
};

export default function Home() {
  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <HeroSection />
      <FeaturedComics />
      <LatestUpdates />
      <ReaderReview />
      <CTASection />
      <FAQSection />
    </Layout>
  );
}